/** Sentiment is a 0–1 float. Stored snapshots sometimes leak 0–100 integers. */
export function normalizeSentiment(raw: number | null | undefined): number {
  const n = Number(raw);
  if (!Number.isFinite(n)) return 0;
  if (n > 1 && n <= 100) return n / 100;
  if (n > 100) return 1;
  if (n < 0) return 0;
  return n;
}

export function moodEmoji(s: number): string {
  const v = normalizeSentiment(s);
  if (v >= 0.70) return '😊';
  if (v >= 0.55) return '🤨';
  if (v >= 0.40) return '😔';
  return '😨';
}

export function sentimentColor(s: number): string {
  const v = normalizeSentiment(s);
  if (v >= 0.70) return '#10B981';
  if (v >= 0.55) return '#64748B';
  if (v >= 0.40) return '#F59E0B';
  return '#EF4444';
}
